// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__6vTBX","content":"styles_content__2AXGl","checkbox":"styles_checkbox__4qxZy","checkboxLabel":"styles_checkboxLabel__zfi7q"};